import React from 'react';
import { Route } from 'react-router-dom';

//!TODO convertion typescript resolve proptypes

function RouteWithLayout(props) {
  const { layout: Layout, component: Component, layoutProps, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout {...layoutProps}>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  );
}

RouteWithLayout.defaultProps = {
  path: null,
};

export default RouteWithLayout;
